export const CompanyIcon = ({ activeColor }: { activeColor?: string }) => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Background */}
            <rect
                width="32"
                height="32"
                rx="8"
                fill="#e0e7ff"
            />

            {/* Building */}
            <path
                d="M11 24V11C11 10.4477 11.4477 10 12 10H20C20.5523 10 21 10.4477 21 11V24"
                stroke={activeColor}
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />

            {/* Windows */}
            <path d="M14 13H15" stroke={activeColor} strokeWidth="1.8" strokeLinecap="round" />
            <path d="M17 13H18" stroke={activeColor} strokeWidth="1.8" strokeLinecap="round" />
            <path d="M14 16H15" stroke={activeColor} strokeWidth="1.8" strokeLinecap="round" />
            <path d="M17 16H18" stroke={activeColor} strokeWidth="1.8" strokeLinecap="round" />
            <path d="M14 19H15" stroke={activeColor} strokeWidth="1.8" strokeLinecap="round" />
            <path d="M17 19H18" stroke={activeColor} strokeWidth="1.8" strokeLinecap="round" />

            {/* Door */}
            <path
                d="M15 24V21H17V24"
                stroke={activeColor}
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />

            {/* Ground */}
            <path
                d="M9 24H23"
                stroke={activeColor}
                strokeWidth="1.8"
                strokeLinecap="round"
            />
        </svg>
    );
}
    